import React,{Component} from "react";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isSet } from "../../../Utils/CommonFunctions";
import SwitchElements from "./Elements/SwitchElements";
import { findClosestSelectableElement } from "../HTMLBuilderfunction";


class MainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentId:null
    }
  }

  
    
   handleDragOver = (event, acceptElement = []) => {
        event.preventDefault();
        // Retrieve the dragged item data from dataTransfer
        // const receivedItemJSON = event.dataTransfer.getData('element');
        // console.log('event',event.relatedTarget);
        // if (receive.dItemJSON) {
          // const item = JSON.parse(receivedItemJSON);
        //   console.log('receivedItemJSON', receivedItemJSON);
        //   console.log('draggingElmt', item);
        //   console.log('acceptElement', acceptElement);
        // }
  
        // You can now work with 'item' here.
    };    

  render(){
    const {htmlContentItems,currentElement} = this.props;
    const {handleDragEnd,handleDrop,setSelectedCurrentId} =this.props;
     const eventDefProps = {
      'data-selectable':true,
      
      onMouseOut:(e)=>this.handleMouseOut(e),
      onDragLeave:(e)=>this.handleMouseOut(e)
    }
    const eventProps = {
      handleMouseOver:(e,id)=>this.handleMouseOver(e,id),
      onSelectClickHandler:this.onSelectClickHandler,
    }
    return(
        <div className="" style={{background:'rgb(244, 244, 244)',padding:'10px',width:'900px'}}>
            <div className="bodyClassApply" style={{display:'flex',...isSet(htmlContentItems.attributes.style, {})}}>
                <div className="builderElement container" style={{minHeight:'400px',textAlign:'center',paddingTop:'20px',paddingLeft:'0px',paddingRight:'0px'}} 
                     onDragOver={this.handleDragOver}
                    onDrop={(e) => {
                    e.preventDefault(); // Prevent the default behavior
                    e.stopPropagation(); // Stop event propagation
                    handleDrop(e);
                    }}>
                    <DragDropContext onDragEnd={(evnt)=>handleDragEnd(evnt)}>
                    {(isSet(htmlContentItems.children,[]).length>0)?
                            <Droppable droppableId="destination">
                            {(provided) => (
                            <div ref={provided.innerRef} {...provided.droppableProps}>
                                {
                                    isSet(htmlContentItems.children,[]).map((item, index) => {
                                    console.log('item==',item)
                                    return (
                                        <Draggable key={item.id} draggableId={item.id+'_'+index} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            onDragOver={(e) => {
                                                e.stopPropagation(); // Stop event propagation
                                                this.handleDragOver(e, item.acceptDestination);
                                            }}
                                            // onDragLeave={this.props.handleDragLeave}
                                            className={snapshot.isDragging ? 'dragging-item' : ''}
                                            >
                                            <SwitchElements 
                                                {...item} 
                                                key={'tollItem_'+item.id}
                                                itemIndex={index}
                                                // idsPath
                                                {...eventProps}
                                                eventDefProps={eventDefProps}
                                                currentId={this.state.currentId}
                                                handleDragEnd={handleDragEnd} 
                                                htmlContentItems={htmlContentItems}
                                                currentElement={currentElement}
                                                handleDrop={handleDrop}
                                                setSelectedCurrentElement={setSelectedCurrentId}
                                                setDestinationItems={this.props.setDestinationItems}
                                                onChangePropertiesHandler={this.props.onChangePropertiesHandler}
                                                deleteElements={this.props.deleteElements}
                                            />
                                            </div>
                                        )}
                                        </Draggable>
                                    );
                                    })
                                }
                                {provided.placeholder}
                            </div>
                            )}
                            </Droppable>
                        
                    :
                    <>
                        <div className="html-builder-empty-block" style={{zIndex: '112'}}>
                            <div>No Layout here. Drag from left.</div>
                        </div>
                    </>}
                    
                </DragDropContext>
                </div>
            </div>
        </div>
    )
  }
  onSelectClickHandler = ()=>{
    // console.log('currentId',this.state.currentId);
    this.props.setSelectedCurrentId(this.state.currentId);
  }

  handleMouseOver = async (e, id = null) => {
    const element = e.target;
    //console.log('element',element);
    const isSelectable = element.getAttribute('data-selectable');
    if (isSelectable === 'true' && !element.hasAttribute('data-attributeid')) {
      element.style.outline = '1px solid #2196F3';
      element.setAttribute('data-attributeid', id);
      //console.log('check...inner');
      this.setCurrentId(id);
    } else {
      const closestSelectableElement = findClosestSelectableElement(element);
      if (closestSelectableElement && !closestSelectableElement.hasAttribute('data-attributeid')) {
        closestSelectableElement.style.outline = '1px solid #2196F3';
        closestSelectableElement.setAttribute('data-attributeid', id);
        //console.log('check...outer');
        this.setCurrentId(id);
      }
    }
  };
    setCurrentId = (id)=>{
      this.setState({currentId:id});
    }

    handleMouseOut = (e) => {
    const element = e.target;
    const isSelectable = element.getAttribute('data-selectable');
    if (isSelectable === 'true') {
      element.style.outline = '';
      element.removeAttribute('data-attributeid');
    } else {
      const closestSelectableElement = findClosestSelectableElement(element);
      if (closestSelectableElement) {
        closestSelectableElement.style.outline = '';
        closestSelectableElement.removeAttribute('data-attributeid');
      }else{
        element.removeAttribute('data-attributeid');
      }
    }
    };

}



// const MainContainer = (props)=>{
//     const {htmlContentItems,currentElement} = props;
//     const {handleDragEnd,handleDrop,setSelectedCurrentId} =props;
    
//   const handleDragOver = (event, acceptElement = []) => {
//         event.preventDefault();
//         // Retrieve the dragged item data from dataTransfer
//         const receivedItemJSON = event.dataTransfer.getData('element');
//         // console.log('event',event.relatedTarget);
//         if (receivedItemJSON) {
//           const item = JSON.parse(receivedItemJSON);
//         //   console.log('receivedItemJSON', receivedItemJSON);
//         //   console.log('draggingElmt', item);
//         //   console.log('acceptElement', acceptElement);
//         }
  
//         // You can now work with 'item' here.
//     };    



//     return(
//         <div className="" style={{background:'rgb(244, 244, 244)',padding:'10px',width:'900px'}}>
//             <div className="bodyClassApply" style={{display:'flex',...isSet(htmlContentItems.attributes.style, {})}}>
//                 <div className="builderElement container" style={{minHeight:'400px',textAlign:'center',paddingTop:'20px',paddingLeft:'0px',paddingRight:'0px'}} 
//                      onDragOver={handleDragOver}
//                     onDrop={(e) => {
//                     e.preventDefault(); // Prevent the default behavior
//                     e.stopPropagation(); // Stop event propagation
//                     handleDrop(e);
//                     }}>
//                     <DragDropContext onDragEnd={(evnt)=>handleDragEnd(evnt)}>
//                     {(isSet(htmlContentItems.children,[]).length>0)?
//                             <Droppable droppableId="destination">
//                             {(provided) => (
//                             <div ref={provided.innerRef} {...provided.droppableProps}>
//                                 {
//                                     isSet(htmlContentItems.children,[]).map((item, index) => {
//                                     console.log('item==',item)
//                                     return (
//                                         <Draggable key={item.id} draggableId={item.id+'_'+index} index={index}>
//                                         {(provided, snapshot) => (
//                                             <div
//                                             ref={provided.innerRef}
//                                             {...provided.draggableProps}
//                                             {...provided.dragHandleProps}
//                                             onDragOver={(e) => {
//                                                 e.stopPropagation(); // Stop event propagation
//                                                 handleDragOver(e, item.acceptDestination);
//                                             }}
//                                             // onDragLeave={props.handleDragLeave}
//                                             className={snapshot.isDragging ? 'dragging-item' : ''}
//                                             >
//                                             <SwitchElements 
//                                                 {...item} 
//                                                 key={'tollItem_'+item.id}
//                                                 itemIndex={index}
//                                                 // idsPath
//                                                 handleDragEnd={handleDragEnd} 
//                                                 htmlContentItems={htmlContentItems}
//                                                 currentElement={currentElement}
//                                                 handleDrop={handleDrop}
//                                                 setSelectedCurrentElement={setSelectedCurrentId}
//                                                 setDestinationItems={props.setDestinationItems}
//                                                 onChangePropertiesHandler={props.onChangePropertiesHandler}
//                                             />
//                                             </div>
//                                         )}
//                                         </Draggable>
//                                     );
//                                     })
//                                 }
//                                 {provided.placeholder}
//                             </div>
//                             )}
//                             </Droppable>
                        
//                     :
//                     <>
//                         <div className="html-builder-empty-block" style={{zIndex: '112'}}>
//                             <div>No Layout here. Drag from left.</div>
//                         </div>
//                     </>}
                    
//                 </DragDropContext>
//                 </div>
//             </div>
//         </div>
//     )
// }


export default MainContainer;